import { DatePicker } from "antd";
import moment from "moment";

import styles from "./date-range-filter.module.css";

export interface DateRangeFilterProps {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  onStartDateChange: (date: moment.Moment | null) => void;
  onEndDateChange: (date: moment.Moment | null) => void;
  validationError?: string;
}

const DATE_FORMAT = "MM/DD/YYYY";

function disableFutureDates(current: moment.Moment) {
  return current && current > moment().endOf("day");
}

export function DateRangeFilter({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  validationError,
}: DateRangeFilterProps) {
  return (
    <div className={styles.filterContainer}>
      <div className={styles.filterRow}>
        <div className={styles.filterField}>
          <label className={styles.filterLabel} htmlFor="insights-start-date">
            From
          </label>
          <DatePicker
            id="insights-start-date"
            value={startDate}
            onChange={onStartDateChange}
            format={DATE_FORMAT}
            disabledDate={disableFutureDates}
            allowClear={true}
            placeholder="Start date"
            status={validationError ? "error" : undefined}
            onBlur={(e) => {
              // Known issue that you cannot clear with only the keyboard
              // https://github.com/ant-design/ant-design/issues/48748
              if (e.target.value === "") {
                onStartDateChange(null);
              }
            }}
          />
        </div>
        <div className={styles.filterField}>
          <label className={styles.filterLabel} htmlFor="insights-end-date">
            To
          </label>
          <DatePicker
            id="insights-end-date"
            value={endDate}
            onChange={onEndDateChange}
            format={DATE_FORMAT}
            disabledDate={disableFutureDates}
            allowClear={true}
            placeholder="End date"
            status={validationError ? "error" : undefined}
            onBlur={(e) => {
              // Known issue that you cannot clear with only the keyboard
              // https://github.com/ant-design/ant-design/issues/48748
              if (e.target.value === "") {
                onEndDateChange(null);
              }
            }}
          />
        </div>
      </div>
      {validationError && (
        <div className={styles.validationError} role="alert">
          {validationError}
        </div>
      )}
    </div>
  );
}
